import { Spin } from 'antd';
import React from 'react';
import { observer } from 'mobx-react';

import store from './Store';
import Table from './Table';
import Toolbar from './Toolbar';
import Modal from './Modal';

import dashboardStore from '@stores/dashboard';
import * as api from '@stores/api';

@observer
class FundingAgreement extends React.Component {
  componentDidMount() {
    if (!api.isAdminOrMagStaffOrAccounting()) {
      dashboardStore.close('/view/funding-agreement', true);
      return;
    }
    store.fetchData(true);
  }
  render() {
    const { data, loading, open } = store;
    return (
      <div className={`Table-${loading && !data ? 'loading' : 'container'}`}>
        {loading && !data ? (
          <Spin size="large" />
        ) : (
          <React.Fragment>
            <Toolbar />
            <Table />
            {open && <Modal />}
          </React.Fragment>
        )}
      </div>
    );
  }
}
export default FundingAgreement;
